
import MembershipOverview from '../components/membership/Overview/MembershipOverview';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useTheme } from '../context/ThemeContext';
import { getPageBackground } from '../utils/themeUtils';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { postEmbedSignal } from '../utils/embedSignals';

const MembershipSummary: React.FC = () => {
    const { isDarkMode } = useTheme();
    const location = useLocation();
    const routeState = (location.state || {}) as {
      formData?: unknown;
      paymentSuccess?: boolean;
      paymentPending?: boolean;
    };
    const justRegistered = !!routeState.formData;
    const paymentSuccess = routeState.paymentSuccess === true;
    const paymentPending = routeState.paymentPending === true;
    // The registration wizard lands here when a registration is complete
    // (it arrives with the family's answers in the route state). When the
    // form is embedded on the club's own website, tell the host page — the
    // Integrations page documents this signal, and before 2026-10-10 only the
    // event pages ever sent it. Nothing personal goes in the message.
    useEffect(() => {
      if (!justRegistered) return;
      postEmbedSignal('clubcentral:complete', {
        widget: 'register',
        paymentSuccess,
        paymentPending,
      });
    }, [justRegistered, paymentSuccess, paymentPending]);
    return (
      <div className="flex flex-col min-h-screen">
        <Header />
        <div className={`flex-1 ${getPageBackground(isDarkMode)}`}>
          <MembershipOverview />
        </div>
        <Footer />
      </div>
    );
  };
  
  export default MembershipSummary;
